import ProfessionSectionHeadline from "./ProfessionSectionHeadline";
import ProfessionCards from "./ProfessionCards";

import data from "../data/professionData.json";
import { PaperBG } from "../kits";

/**
 * ProfessionSection - Main section combining headline and cards
 * Now uses modular components for better flexibility
 */
function ProfessionSection() {
  return (
    <PaperBG>
      <ProfessionSectionHeadline />
      <ProfessionCards data={data} />
    </PaperBG>
  );
}

export default ProfessionSection;
